import React from "react";
import { cn } from "@/lib/utils";

/** Barra fina de avance, sobria — nunca un donut decorativo. */
export const ProgressBar = ({ pct = 0, testId, className }) => {
  const clamped = Math.max(0, Math.min(100, pct));
  return (
    <div className={cn("flex items-center gap-2", className)} data-testid={testId}>
      <div className="h-1 w-14 shrink-0 overflow-hidden rounded-full bg-line">
        <div className="h-full bg-ink" style={{ width: `${clamped}%` }} />
      </div>
      <span className="font-mono text-[11.5px] tabular-nums text-ink-secondary">{clamped}%</span>
    </div>
  );
};
